module.exports = __webpack_public_path__ + "static/Picture-aa66531e90524fd067655df5a5e27a8b.png";